import { attachLaborBreakdownTablePaging } from '../labor-cost-breakdown-paging-helper';

class LaborProjectCostBreakdownModalController {
  constructor(
    $uibModalInstance,
    $scope,
    reportPeriodLabel,
    laborProjectPie,
    laborPieChartOptions,
    laborProjectBreakdownRows,
    formatStatCurrencyFn
  ) {
    'ngInject';
    const self = this;
    self.$uibModalInstance = $uibModalInstance;
    self.reportPeriodLabel = reportPeriodLabel;
    self.laborProjectPie = laborProjectPie;
    self.laborPieChartOptions = laborPieChartOptions;
    self.laborProjectBreakdownRows = laborProjectBreakdownRows;
    self.formatStatCurrency = formatStatCurrencyFn;

    attachLaborBreakdownTablePaging($scope, self, 'project', function() {
      return self.laborProjectBreakdownRows;
    }, '0 projects');
  }

  close() {
    this.$uibModalInstance.dismiss();
  }
}

export default LaborProjectCostBreakdownModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/modals/labor-project-cost-breakdown-modal/labor-project-cost-breakdown-modal.controller.js